export enum ImageBannerName {
  DailyMenuAlert = "daily-menu-alert",
  AdminDashLunchBanner = "admin-dash-lunch-banner",
  DailyMenuPromoBanner = "daily-menu-promo-banner",
}

export type BannerImageItem = {
  href: string | null;
  id: number;
  image: string | null;
  mobile_image: string | null;
  text: string;
};
